import api from './axios'

/**
 * WhatsApp Business API service
 * Handles configuration and messaging through WhatsApp Cloud API
 */
export const whatsappApi = {
    // Configuration
    getConfig: async (formId) => {
        const response = await api.get(`/forms/${formId}/whatsapp`)
        return response.data
    },

    saveConfig: async (formId, config) => {
        const response = await api.post(`/forms/${formId}/whatsapp`, config)
        return response.data
    },

    testConnection: async (formId) => {
        const response = await api.post(`/forms/${formId}/whatsapp/test`)
        return response.data
    },

    deleteConfig: async (formId) => {
        const response = await api.delete(`/forms/${formId}/whatsapp`)
        return response.data
    },

    // Messages
    getMessages: async (params = {}) => {
        const response = await api.get('/whatsapp/messages', { params })
        return response.data
    },

    getMessage: async (id) => {
        const response = await api.get(`/whatsapp/messages/${id}`)
        return response.data
    },

    sendReply: async (messageId, content) => {
        const response = await api.post(`/whatsapp/messages/${messageId}/reply`, { content })
        return response.data
    },

    updateStatus: async (messageId, status) => {
        const response = await api.put(`/whatsapp/messages/${messageId}/status`, { status })
        return response.data
    },

    getStats: async (formId = null) => {
        const params = formId ? { form_id: formId } : {}
        const response = await api.get('/whatsapp/stats', { params })
        return response.data
    }
}

export default whatsappApi
